import { atom } from "recoil";

export const groupedFixturesState = atom({
  key: "groupedFixturesState",
  default: { groupedFixturesByDay: [], items: [], uniqueFixtureDates: [] },
});
